define.alias("shared/components/shared/base-time-picker", "settings/components/shared/base-time-picker");